/**
 * GraphQL request throttle for local development.
 * Adds an artificial delay to all GraphQL requests to simulate API latency.
 */

import { load, save } from "src/utils/storage";

const STORAGE_KEY = "dev-graphql-throttle-ms";

let throttleMs = 0;

// Restore persisted value on module load
const stored = load(STORAGE_KEY);
if (typeof stored === "number" && stored > 0) {
  throttleMs = stored;
}

export function getGraphqlThrottleMs(): number {
  return throttleMs;
}

export function setGraphqlThrottleMs(ms: number): void {
  throttleMs = Math.max(0, Math.round(ms));
  save(STORAGE_KEY, throttleMs);
}

export function applyGraphqlThrottle(): Promise<void> | undefined {
  if (throttleMs > 0) {
    return new Promise((resolve) => setTimeout(resolve, throttleMs));
  }
  return undefined;
}
